import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Users, Code2, Building2, Award, ArrowRight } from 'lucide-react';

export const WhyUs = () => {
  const features = [
    {
      icon: Code2,
      title: "Hands-On Experience with Live Client Projects",
      //stat: "Production-Grade Applications", 
      description: "Collaborate with GJ Global development teams to deliver real client requirements, gaining experience beyond simulated or academic projects.",
      highlights: ["Mentorship from active industry professionals", "Practical real-world guidance", "Exposure to current industry practices", "Career-oriented technical insights"]
    },
    {
      icon: Users,
      title: "Mentorship from Industry-Experienced Developers",
     // stat: "10+ Years Experience",
      description: "Learn under the guidance of senior developers from GJ Global who actively work on live projects and bring current industry expertise into the training environment..",
      highlights: ["Active developers", "Agile team collaboration", "Production deployment exposure", "Industry-standard development practices"]
    },
    {
      icon: Building2,
      title: "Industry-Relevant Professional Portfolio",
      //stat: "Deployed applications",
      description: "Develop applications used by real users, enabling you to build a professional portfolio that demonstrates practical problem-solving and measurable business impact.",
      highlights: ["User-facing enterprise applications", "Business-oriented development approach", "Real-world problem-solving experience", "Industry-standard technical documentation"]
    },
    {
      icon: Award,
      title: "Backed by an Established Technology Company",
     // stat: "Backed by GJ Global,
      description: "Leverage GJ Global 4+ years of industry experience, established development processes, and strong professional network.",
      highlights: ["Proven enterprise development processes", "High-quality delivery standards", "Strong industry and professional connections", "Structured corporate working environment"]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl font-bold text-gray-900">
Why Choose GJ Global SkillBay Buddy Training        </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
           Unlike conventional training institutes, our programs are delivered in collaboration with GJ Global development teams, providing hands-on exposure to live client projects and production-grade applications
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto mb-16">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Card 
                key={index} 
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-blue-200 bg-gradient-to-br from-white to-gray-50"
              >
                <CardContent className="p-8">
                  <div className="space-y-6">
                    {/* Icon & Title */}
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600 transition-colors">
                        <IconComponent className="w-6 h-6 text-blue-600 group-hover:text-white transition-colors" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                        
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-gray-700 leading-relaxed">
                      {feature.description}
                    </p>

                    {/* Highlights */}
                    <div className="grid grid-cols-2 gap-2">
                      {feature.highlights.map((highlight, idx) => (
                        <div key={idx} className="flex items-center gap-2 text-sm text-gray-600">
                          <div className="w-1.5 h-1.5 bg-blue-500 rounded-full flex-shrink-0" />
                          {highlight}
                        </div>
                      ))}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Stats Row */}
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          <div className="text-center space-y-2">
            <div className="text-3xl font-bold text-slate-600">300+</div>
            <p className="text-gray-600">Professionals Trained</p>
            <p className="text-sm text-gray-500">Across multiple technology domains</p>
          </div>
          
          <div className="text-center space-y-2">
            <div className="text-3xl font-bold text-slate-600">50+</div>
            <p className="text-gray-600">Live Client Projects</p>
            <p className="text-sm text-gray-500">Delivered through real-world implementations</p>
          </div>
          
          <div className="text-center space-y-2">
            <div className="text-3xl font-bold text-slate-600">4+</div>
            <p className="text-gray-600">Years of GJ Global</p>
            <p className="text-sm text-gray-500">GJ Global legacy</p>
          </div>
          
          <div className="text-center space-y-2">
            <div className="text-3xl font-bold text-slate-600">40+</div>
            <p className="text-gray-600">Industry Mentors</p>
            <p className="text-sm text-gray-500">Senior and active professionals</p>
          </div>
        </div>

        {/* CTA Section */}
        {/* <div className="text-center space-y-6">
          <div className="flex flex-wrap justify-center gap-4">
            <button 
              className="text-blue-600 hover:text-blue-700 font-medium flex items-center gap-2 hover:underline"
              onClick={() => document.getElementById('mentors')?.scrollIntoView({ behavior: 'smooth' })}
            >
Download Full Syllabus              <ArrowRight size={16} />
            </button>
            
            <span className="text-gray-400">•</span>
            
            <button 
              className="text-blue-600 hover:text-blue-700 font-medium flex items-center gap-2 hover:underline"
              onClick={() => window.open('https://github.com/gjskillbay', '_blank')}
            >
View Sample Projects              <ArrowRight size={16} />
            </button>
            
            <span className="text-gray-400">•</span>
            
            <button 
              className="text-blue-600 hover:text-blue-700 font-medium flex items-center gap-2 hover:underline"
              onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
            >
             Meet Our Mentors
              <ArrowRight size={16} />
            </button>
          </div>
        </div> */}
      </div>
    </section>
  );
};